const ROLE_MAP = {
  admin: "admin",
  employer: "employer",
  applicant: "applicant",
  press: "press",
  arbeitgeber: "employer",
  bewerber: "applicant",
  presse: "press",
};

export function normalizeRole(role) {
  return ROLE_MAP[String(role || "").toLowerCase()] || String(role || "").toLowerCase();
}

